import styled from "styled-components/macro";

export const Content = styled.div(({ theme }) => ({
  margin: "auto",
  display: "flex",
  justifyContent: "center",

  [theme.breakpoint.lg()]: {
    justifyContent: "flex-start",
    padding: "0px",
  },
}));
